// @ts-check
import agoraSubjectMap from '../data/agoraSubjectMap.json'
import { NormalizedLevel, SubLevel } from './constants'

const ALL_AGORA_MAPPINGS = Object.values(agoraSubjectMap).flat()
const AGORA_SUBJECT_INFO_BY_ID = ALL_AGORA_MAPPINGS.reduce((acc, m) => {
  acc[m.agoraSubjectId] = m
  return acc
}, {})

export function getAllAgoraMappings() {
  return ALL_AGORA_MAPPINGS
}

export function getAgoraSubjectInfo(agoraSubjectId) {
  return AGORA_SUBJECT_INFO_BY_ID[agoraSubjectId] || null
}

const NORMALIZED_LEVEL_TO_CSV_LEVELS = {
  [NormalizedLevel.PRIMARY]: ['PRIMARIA'],
  [NormalizedLevel.SECONDARY_LOW]: ['SECUNDARIA'],
  [NormalizedLevel.SECONDARY_HIGH]: ['BACHILLERATO', 'BACHILLERATO INT.'],
  [NormalizedLevel.TERTIARY]: ['UNIVERSIDAD', 'FP']
}

const CSV_LEVEL_LABELS = {
  PRIMARIA: 'Primaria',
  SECUNDARIA: 'Secundaria',
  BACHILLERATO: 'Bachillerato',
  'BACHILLERATO INT.': 'Bachillerato Int.',
  UNIVERSIDAD: 'Universidad',
  FP: 'FP',
  IDIOMA: 'Idioma',
  OTRAS: 'Otras'
}

export function getCsvLevelLabel(csvLevel) {
  return CSV_LEVEL_LABELS[csvLevel] ?? csvLevel
}

function getCsvLevelTiers(normalizedLevel, subLevel) {
  const base = NORMALIZED_LEVEL_TO_CSV_LEVELS[normalizedLevel]
  if (!base) return []
  const intl = base.filter(l => l.endsWith(' INT.'))
  const nonIntl = base.filter(l => !l.endsWith(' INT.'))
  if (subLevel === SubLevel.INTERNATIONAL)
    return [intl, nonIntl].filter(t => t.length)
  return [nonIntl].filter(t => t.length)
}

/**
 * Resolves a Classfy subject UUID into the matching Agora ObjectIds.
 * @param {string} classfyUuid
 * @param {string|null|undefined} normalizedLevel
 * @param {string|null|undefined} [subLevel]
 * @returns {{ matches: Array<{agoraSubjectId: string, level: string, name: string}>, mode: 'exact' | 'all' | 'none' }}
 */
export function resolveAgoraSubjects(classfyUuid, normalizedLevel, subLevel) {
  if (!classfyUuid) return { matches: [], mode: 'none' }
  const all = agoraSubjectMap[classfyUuid]
  if (!all || all.length === 0) return { matches: [], mode: 'none' }

  if (normalizedLevel) {
    const tiers = getCsvLevelTiers(normalizedLevel, subLevel)
    for (const tier of tiers) {
      const filtered = all.filter(m => tier.includes(m.level))
      if (filtered.length > 0) return { matches: filtered, mode: 'exact' }
    }
  }

  return { matches: all, mode: 'all' }
}
